import { liteClient as algoliasearch } from 'algoliasearch/lite';

export const searchClient = algoliasearch(
    'PBGUU8YPJQ',
    'a3d1a8590388a1b7121896f50e9cf450'
);